import { HeroCard } from 'ui/components';

export const HeroCardFeature: React.FC<Umbraco.HeroCard> = ({ content, settings }) => <HeroCard {...content?.properties} {...settings?.properties} />;
